var exports = {
  "Gh": "BlockedUsersTab.module__userList___MUVDQm",
  "Kg": "BlockedUsersTab.module__userCard___MUVDQm",
  "eF": "BlockedUsersTab.module__userInfo___MUVDQm",
  "KI": "BlockedUsersTab.module__avatarButton___MUVDQm",
  "xO": "BlockedUsersTab.module__usernameButton___MUVDQm",
  "QV": "BlockedUsersTab.module__usernameContainer___MUVDQm",
  "Xh": "BlockedUsersTab.module__username___MUVDQm",
  "p$": "BlockedUsersTab.module__handle___MUVDQm",
  "o1": "BlockedUsersTab.module__actions___MUVDQm",
  "lK": "BlockedUsersTab.module__moreIcon___MUVDQm",
};

module.exports = exports;
